import { Component } from 'react';
import { Box, Typography, Button } from '@mui/material';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        console.error('Uncaught error:', error, info);
    }

    render() {
        if (this.state.hasError) {
            return (
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: '100vh',
                        gap: 2,
                        p: 4,
                    }}
                >
                    <Typography variant="h5">Something went wrong</Typography>
                    <Typography variant="body1" color="text.secondary" textAlign="center">
                        The app ran into an unexpected error. Please try refreshing.
                    </Typography>
                    <Button variant="contained" onClick={() => window.location.reload()}>
                        Refresh
                    </Button>
                </Box>
            );
        }
        return this.props.children;
    }
}

export default ErrorBoundary;
